import instance from "@/services/api";

export const workChecksAPI = {
  async getWorkChecksList(params) {
    return await instance()
      .get("/handbook/sbs_work_check/read/", { params })
      .then((res) => res?.data);
  },
  
  async modifyWorkCheck(data) {
    return await instance()
      .post("/handbook/sbs_work_check/modify/", data)
      .then((res) => res?.data);
  },
  
  async deleteWorkCheck(sbsWorkCheckId) {
    return await instance()
      .delete(`/handbook/sbs_work_check/${sbsWorkCheckId}/delete/`)
      .then((res) => res?.data);
  },

  async getProjectTypes() {
    return await instance()
      .get("/project_list/project/type/")
      .then((res) => res?.data);
  },

  async getWorkSetCheckGroups() {
    return await instance()
      .get("/common/work_set_check_groups/read/")
      .then((res) => res?.data);
  },

  async getCheckLists() {
    return await instance()
      .get("/common/check_lists/read/")
      .then((res) => res?.data);
  },

  async getAllPlacementTypes() {
    return await instance()
      .get("/project/common/placement_types/read/")
      .then((res) => res?.data);
  },

  async getAssignTypes() {
    return await instance()
      .get("/handbook/sbs_work_check/assign_type_check_list/read/")
      .then((res) => res?.data);
  },
};

